import React from 'react'
import ChartWidgets from '../../../Components/Widgets/Chart'

export default function Chart() {
    return (
        <div className='page-body'>
            <ChartWidgets />
        </div>
    )
}